import React, { memo, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  listReports,
  selectListReports,
} from "../../redux";

function Reports() {
  const dispatch = useDispatch();

  const [visibleCount, setVisibleCount] = useState(5);

  const listReportsData = useSelector(selectListReports);
  const data = listReportsData?.data || [];

  useLayoutEffect(() => {
    handleFetchData();
  }, []);

  const handleFetchData = () => {
    dispatch(listReports());
  };

  const isLoading = listReportsData?.data === undefined;
  const isEmptyData = !isLoading && data.length === 0;

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 5);
  };

  const hasMore = data.length > visibleCount;

  return (
    <div>
      <canvas id="confetti" style={{ display: 'none' }}></canvas>
      <div className="m-pager-title">
        <div className="m-pager-title__inner">
          <p className="m-pager-title__inner__title">アンケート結果</p>
        </div>
      </div>
      <div className="t-contents t-contents--bg-ivory">
        <div className="t-contents__body t-contents__body--slider">
          {isLoading ? (
            <p
              className="o-mypage-survey-slider__margin__wrap__box__title"
              style={{ textAlign: "center" }}
              id="loadMessage"
            >
              読み込み中...
            </p>
          ) : isEmptyData ? (
            <p
              className="o-mypage-survey-slider__margin__wrap__box__title"
              style={{ textAlign: "center" }}
            >
              現在公開中のアンケート結果はありません。
            </p>
          ) : (
            <>
              {data.slice(0, visibleCount).map((prod, idx) => (
                <div
                  className="o-entry"
                  style={{ textAlign: "center", marginBottom: "20px", maxWidth: "780px" }}
                >
                  <a
                    style={{ cursor: "pointer", background: "#fff", padding: "15px", border: "solid 2px #000", color: "#000" }}
                    className="a-button a-button--round u-fz16"
                    href={prod.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {prod.name}
                  </a>
                </div>
              ))}

              {hasMore && (
                <div
                  className="o-entry"
                  style={{ textAlign: "center", marginTop: "50px", maxWidth: "780px" }}
                >
                  <button
                    type="button"
                    style={{ cursor: "pointer", background: "#17913c", color: "#fff" }}
                    className="a-button a-button--round u-fz16"
                    onClick={handleShowMore}
                  >
                    もっと見る
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default memo(Reports);
